module.exports = __webpack_public_path__ + "assets/img/icon10-menu2.bb22733a.svg";